export default "__VITE_ASSET__BEztggij__"